<template>
  <div
    class="container-fluid infinite-list"
    infinite-scroll-immediate="false"
    infinite-scroll-disabled="disabled"
    v-infinite-scroll="getResumeList"
  >
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <div class="tool-list">
      <button
        type="button"
        class="btn btn-secondary btn-sm"
        style="margin-right: 10px"
        @click="$router.back()"
      >
        返回
      </button>
      <!-- 新增履歷 -->
      <CreateResume
        class="tool-list-item create-resume-button"
        @getResumeList="
          (currentPage = 1),
            (personList = []),
            (totalPerson = 0),
            getResumeList()
        "
      />
      <button
        type="button"
        class="btn btn-outline-info btn-sm tool-list-item"
        data-toggle="modal"
        data-target="#uploadModal"
      >
        匯入資料
      </button>
      <!-- 卡片顯示樣式 -->
      <div v-if="personList.length > 0" class="tool-list-about-card">
        <span
          @click="gridStyle = 'block'"
          :class="{ active: gridStyle == 'block' }"
        >
          <eva-icon fill="#000" name="grid-outline" />
        </span>
        <span
          @click="gridStyle = 'list'"
          :class="{ active: gridStyle == 'list' }"
        >
          <eva-icon fill="#000" name="list-outline" />
        </span>
      </div>
    </div>

    <!-- 人員卡片 -->
    <div
      class="person-card-list"
      :class="{
        'list-style': gridStyle == 'list',
        'block-style': gridStyle == 'block',
      }"
    >
      <div
        v-for="(person, index) in personList"
        :key="index"
        class="person-card infinite-list-item"
      >
        <PersonCard ref="personCard" :showCheckbox="false" :person="person">
          <template v-slot:tag="{ props }">
            <div class="result">{{ props.InterviewResult }}</div>
          </template>

          <template v-slot:middleContent="{ props }">
            <table>
              <tr>
                <th>需求單名稱</th>
                <td>{{ props.ManpowerDemandName }}</td>
              </tr>
              <tr>
                <th>應徵職務</th>
                <td>{{ props.Position }}</td>
              </tr>
              <tr>
                <th>學歷</th>
                <td>{{ props.Education[0] }}</td>
              </tr>
              <tr>
                <th></th>
                <td>{{ props.Education[1] }}</td>
              </tr>
              <tr>
                <th>經歷</th>
                <td>{{ props.WorkExperience[0] }}</td>
              </tr>
              <tr>
                <th></th>
                <td>{{ props.WorkExperience[1] }}</td>
              </tr>
              <tr>
                <th>履歷來源</th>
                <td>{{ props.Source }}</td>
              </tr>
              <tr>
                <th>是否發過感謝函</th>
                <td>
                  <span v-if="props.SendThankNoticeTime === null">否</span>
                  <span v-else>是</span>
                </td>
              </tr>
            </table>
          </template>

          <template v-slot:buttonGroup="{ props }">
            <button type="button" @click.prevent="showDetailModal(props)">
              檢視資訊
            </button>
            <button
              v-if="
                props.InterviewResult === '尚未邀約' ||
                props.InterviewResult === '複試'
              "
              type="button"
              @click.prevent="clickInterviewInvitation(props)"
            >
              面談邀約
            </button>
          </template>
        </PersonCard>
      </div>
    </div>

    <!-- 面談邀約 -->
    <InterviewMailModal
      :personData="interviewee"
      @updatePerson="updatePerson"
    />

    <!-- 感謝函 Modal-->
    <ThanksMailModal
      :personData="interviewee"
      @getLatestSearchResult="getResumeList"
    />

    <!-- 匯入資料-->
    <div class="modal fade" id="uploadModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <span>匯入資料</span>
          </div>
          <div class="modal-body" style="margin-bottom: 20px">
            <p class="form-group">
              <u
                style="color: midnightblue; cursor: pointer"
                @click.prevent="$common.downloadResumeTemplate"
              >
                點擊下載範例檔
              </u>
            </p>
            <p class="form-group">
              <span class="mark">* 檔案限制：[檔名].xlsx、[檔名].xls</span>
              <br />
              <span class="mark">* 大小限制：10MB 以下</span><br />
              <span class="mark">* 上傳前請確認是否符合格式</span><br />
            </p>
            <div class="from-group">
              <label for=""><span class="mark">*</span>檔案</label>
              <el-upload
                ref="upload"
                action
                accept=".xls,.xlsx"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="uploadFile"
                :limit="1"
              >
                <el-button size="small" type="primary">點擊上傳</el-button>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 匯入資料 API 回應訊息 -->
    <ResponseDataModal
      :successfulList="successMessage"
      :failedList="failMessage"
    />

    <!-- 檢視資訊 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="detailCurrentPage = 0">
              <span>
                <eva-icon name="person-outline" fill="#FFF"></eva-icon>
                履歷
              </span>
            </a>
            <a
              v-if="showInterviewRecord"
              @click.prevent="detailCurrentPage = 1"
            >
              <span>
                <eva-icon name="message-circle-outline" fill="#FFF"></eva-icon>
                面談紀錄
              </span>
            </a>
            <a
              v-if="showAppointmentRecord"
              @click.prevent="detailCurrentPage = 2"
            >
              <span>
                <eva-icon name="clipboard-outline" fill="#FFF"></eva-icon>
                任用單
              </span>
            </a>
            <div
              class="close-show-detail"
              @click="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              ></eva-icon>
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="$common.downloadResumePDF(ResumeType, ResumeId)"
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 1" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">面談紀錄</div>
                    <div class="item"></div>
                  </div>
                  <InterviewRecord :MatchId="MatchId"></InterviewRecord>
                </section>
              </perfect-scrollbar>
            </transition>
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 2" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">任用單</div>
                    <div class="item"></div>
                  </div>
                  <AppointmentRecord :MatchId="MatchId"></AppointmentRecord>
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* global $ */
import moment from "moment";
// 公司LOGO
import Logo from "@/components/company/Logo.vue";
// 人員卡片
import PersonCard from "@/components/back/Card/Person";
// 新增履歷
import CreateResume from "@/components/back/Modal/CreateResume";
// 面談邀約
import InterviewMailModal from "@/components/back/Modal/InterviewMail";
// 感謝函
import ThanksMailModal from "@/components/back/Modal/ThanksMail";
// API 回應訊息
import ResponseDataModal from "@/components/back/Modal/ResponseData";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";
// 面談紀錄
import InterviewRecord from "@/components/back/CandidateData/InterviewRecord";
// 任用單
import AppointmentRecord from "@/components/back/CandidateData/AppointmentRecord";

export default {
  name: "ResumeList",

  components: {
    Logo,
    PersonCard,
    CreateResume,
    InterviewMailModal,
    ThanksMailModal,
    IdlResume,
    DlResume,
    InterviewRecord,
    ResponseDataModal,
    AppointmentRecord,
  },
  data() {
    return {
      // 卡片顯示樣式 有 block / list 兩種
      gridStyle: "block",

      // 檢視資訊
      MatchId: null,
      ResumeId: null,
      isShowDetail: false, // 預設不顯示
      detailCurrentPage: 0, // 點擊選項
      resumeSource: null, // 履歷來源
      resumeType: null, // 履歷種類
      showInterviewRecord: false, // 面談紀錄

      // 面談邀約
      interviewee: {},

      // 匯入資料-回應訊息
      successMessage: [], // 成功訊息
      failMessage: [], // 失敗訊息

      // 人員卡面列表
      personList: [],

      // 分頁
      totalPerson: 0, // 共幾筆
      currentPage: 1, // 當前第幾頁
      stopGetNextPage: false, // 停止call API（停止取得下一頁）
    };
  },

  methods: {
    // 取得履歷數量列表 API
    getResumeList() {
      const vm = this;
      const demandNo = JSON.parse(localStorage.getItem("ResumeCard")).DemandNo;
      const api = `${window.endpoints.api}/Recruitment/JobManagementByResumeView/V2/paging`;

      if (vm.totalPerson > 0) {
        if (vm.totalPerson > 30) {
          if (vm.totalPerson === vm.personList.length) {
            vm.stopGetNextPage = true;
            return;
          } else {
            vm.currentPage++;
            vm.stopGetNextPage = false;
          }
        } else {
          vm.stopGetNextPage = true;
          return;
        }
      }

      const params = {
        keyword: null,
        Status: null,
        Page: vm.currentPage,
        PerPage: 30,
        ManpowerDemandNo: demandNo,
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .post(api, params)
        .then((response) => {
          if (response.data.Quantity > 0) {
            vm.totalPerson = response.data.Quantity;
            let newArr = response.data.Datas;

            let oldArr;
            if (vm.currentPage === 1) {
              oldArr = [];
            } else {
              oldArr = vm.personList;
            }
            vm.personList = oldArr.concat(newArr);
          }

          vm.$store.dispatch("Interviewing");
          vm.$store.dispatch("Interviewed");
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "履歷數量取得失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 檢視資訊 Modal
    showDetailModal(person) {
      this.MatchId = person.MatchId;
      this.ResumeId = person.ResumeId;
      this.ResumeType = person.ResumeType;
      this.isShowDetail = true;
    },

    // 面談邀約
    clickInterviewInvitation(person) {
      this.interviewee = person;
      this.$store.commit("OpenInterviewMailModal", true);
    },

    // 更新卡片
    updatePerson(matchId) {
      this.personList.forEach((item, index, arr) => {
        if (item.MatchId === matchId) {
          arr[index].InterviewResult = "待面談";
        }
      });
    },

    // 上傳檔案 API (匯入資料)
    uploadFile(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.$notify({
          title: "失敗",
          message: "檔案大小不得超過10MB",
          type: "error",
          duration: 3500,
        });
        return false;
      }

      const vm = this;
      const api = `${window.endpoints.api}/ResumeModule/UploadResumeImport`;

      const resumeType = JSON.parse(
        localStorage.getItem("ResumeCard")
      ).ResumeType;
      const manpowerDemandNo = JSON.parse(
        localStorage.getItem("ResumeCard")
      ).DemandNo;

      let fd = new FormData();
      fd.append("file", file.raw);
      fd.append("userid", vm.$cookies.get("userId"));
      fd.append("resumeType", resumeType);
      fd.append("manpowerDemandNo", manpowerDemandNo);

      $("#uploadModal").modal("hide");
      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .post(api, fd)
        .then((response) => {
          vm.$store.dispatch("updateLoading", false);
          vm.successMessage = response.data.filter((item) => {
            return item.indexOf("成功") !== -1;
          });
          vm.failMessage = response.data.filter((item) => {
            return item.indexOf("失敗") !== -1;
          });
          vm.$store.commit("OpenResponseDataModal", true);
          vm.$refs.upload.clearFiles();
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$refs.upload.clearFiles();
          vm.$notify({
            title: "匯入資料失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    isShowDetail: function (e) {
      if (!e) {
        this.detailCurrentPage = 0;
      }
    },
  },

  filters: {
    moment: function (date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },

  created() {
    this.getResumeList();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
